import React from 'react'

import StudentRouteSection from './StudentRouteSection'

const CourseSection = () => {
  return (
    <div>
      <StudentRouteSection />
    </div>
  )
}

export default CourseSection
